import type {DynamicLabelExtra} from 'src/action-creators/dynamic-labels';
import type {EntityType} from 'src/types/ats-entities';

import * as React from 'react';

import {dedupBridgedDynamicLabels} from 'src/utils/dynamic-labels';
import classify from 'src/utils/classify';

import {
  TokenListInput,
  type TokenListInputProps,
} from 'src/components/lib/token-list-input/new-stuff';
import {MultiEntityLabel} from 'src/components/lib/markdown-editor/dynamic-text';
import {NewVariableDropdownRow} from 'src/components/lib/variable-picker/variable-picker-dropdown-row';

import css from './variable-picker.css';


export default function EntityVariableSelect({
  classNames,
  baseEntityType,
  values = [],
  onChange,
  options,
  limit,
  ...rest
}: TokenListInputProps<DynamicLabelExtra> & {
  options: DynamicLabelExtra[];
  baseEntityType: EntityType;
}) {
  options = React.useMemo(
    // @ts-expect-error - TS2769 - No overload matches this call.
    () => Array.from(dedupBridgedDynamicLabels(options)),
    [options],
  );

  return (
    <TokenListInput
      classNames={mergeClassNames(
        {
          options: css.multiEntityVariableSelectOptions,
        },
        classNames,
      )}
      groupOptionsBy={(option) => option.mapping.display_name}
      sortOptionsBy={(a, b) =>
        (a.entityRelationshipPath?.[0] || a.name).localeCompare(
          b.entityRelationshipPath?.[0] || b.name,
          undefined,
          {
            sensitivity: 'base',
          },
        )
      }
      options={options}
      values={values}
      limit={limit}
      onChange={onChange}
      components={{
        // @ts-expect-error - TS2322 - Type '({ children, className, onClick, option, useNewDesignSystem, }: MultiEntityLabelComponentProps) => React.JSX.Element' is not assignable to type 'ComponentType<TokenProps<any>> | undefined'.
        Token: MultiEntityLabel,
        Suggestion: NewVariableDropdownRow,
      }}
      searchable
      searchOnEmptyString
      {...rest}
    />
  );
}

function mergeClassNames<C extends Record<any, any>>(
  sourceClassNames: C,
  extraClassNames?: C | null,
): C {
  const classNames = {...sourceClassNames} as const;
  if (extraClassNames) {
    for (const key of Object.keys(extraClassNames)) {
      // @ts-expect-error - TS2862 - Type 'C' is generic and can only be indexed for reading.
      classNames[key] = classify(classNames[key], extraClassNames[key]);
    }
  }
  return classNames;
}
